module.exports = __webpack_public_path__ + "img/logo.1eb41d16.png";